import ProductService from "@/services/product_service";
import {
  SURCHARGE_MAX_AGE_MS,
  SurchargeContext,
  SurchargeMutations,
  SurchargeRate
} from "./types";

/**
 * Fetch the surcharge from the API. A failure keeps the last known values: the
 * surcharge only labels prices the API has already calculated, so it must never
 * block pricing.
 */
export const refresh = async (
  context: SurchargeContext,
  force = false
): Promise<void> => {
  const age = Date.now() - context.state.fetchedAt;
  if (!force && age < SURCHARGE_MAX_AGE_MS) return;
  try {
    const surcharge = await new ProductService().getSurchargeInfo();
    context.commit(SurchargeMutations.SetSurcharge, surcharge);
  } catch (err) {
    console.error("Unable to refresh surcharge", err);
  }
};

/**
 * Fallback until a fetch succeeds: every price response carries the rate it was
 * calculated with, so a failed fetch can't leave the surcharge at 0. fetchedAt
 * stays 0, so the next refresh still asks the API, which then owns the values.
 */
export const seed = (
  context: SurchargeContext,
  surcharge: SurchargeRate
): void => {
  if (context.state.fetchedAt === 0) {
    context.commit(SurchargeMutations.SeedSurcharge, surcharge);
  }
};
